module.exports = __webpack_public_path__ + "img/be.49147ca6.svg";